/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RecognizedNew model module.
 * @module model/RecognizedNew
 * @version 1.0
 */
class RecognizedNew {
    /**
     * Constructs a new <code>RecognizedNew</code>.
     * @alias module:model/RecognizedNew
     */
    constructor() { 
        
        RecognizedNew.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RecognizedNew</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RecognizedNew} obj Optional instance to populate.
     * @return {module:model/RecognizedNew} The populated <code>RecognizedNew</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RecognizedNew();

            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('entity')) {
                obj['entity'] = ApiClient.convertToType(data['entity'], 'Number');
            }
            if (data.hasOwnProperty('timelimit')) {
                obj['timelimit'] = ApiClient.convertToType(data['timelimit'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} type
 */
RecognizedNew.prototype['type'] = undefined;

/**
 * @member {Number} status
 */
RecognizedNew.prototype['status'] = undefined;

/**
 * @member {Number} entity
 */
RecognizedNew.prototype['entity'] = undefined;

/**
 * @member {String} timelimit
 */
RecognizedNew.prototype['timelimit'] = undefined;






export default RecognizedNew;

